module.exports = __webpack_public_path__ + "img/assortment.d3e84ddf.svg";